/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {DateInputEl} from 'common/widgets/date-range-picker/calendar-input/date-input';
import {TooltipEl} from 'common/components/tooltip';
import {CalendarEl} from 'common/components/calendar';
import type {CalendarInput} from 'common/widgets/date-range-picker/calendar-input/index';
import {DisplayType} from 'common/components/tooltip/types';

export function template(this: CalendarInput) {
  const {error, focused, from, isRangePicker, to} = this.state;
  const isFixedRange = this.helpers.isFixedRange();

  return (
    <div sel='.calendar-input'>
      <div sel='.date-inputs'>
        <DateInputEl
          sel='.from-date-input'
          class={{focused: focused === `from`}}
          attrs={{
            error: !!error.from,
            value: from,
          }}
          on={{
            blur: this.helpers.blurredFrom,
            change: isFixedRange ? this.helpers.changedFixedRangeFrom : this.helpers.changedFrom,
            focus: this.helpers.focusedFrom,
            mouseenter: this.helpers.mouseenterFrom,
            mouseleave: this.helpers.mouseleaveFrom,
          }}
        />
        {isRangePicker ? (
          <>
            <div sel='.preposition'>and</div>
            <DateInputEl
              sel='.to-date-input'
              class={{focused: focused === `to`}}
              attrs={{
                error: !!error.to,
                value: to,
              }}
              on={{
                blur: this.helpers.blurredTo,
                change: isFixedRange ? this.helpers.changedFixedRangeTo : this.helpers.changedTo,
                focus: this.helpers.focusedTo,
                mouseenter: this.helpers.mouseenterTo,
                mouseleave: this.helpers.mouseleaveTo,
              }}
            />
          </>
        ) : null}
        {error.from && this.helpers.isFromActive() ? (
          <TooltipEl
            attrs={{
              type: DisplayType.Error,
              'always-show': true,
            }}
          >
            {error.from}
          </TooltipEl>
        ) : null}
        {error.to && this.helpers.isToActive() ? (
          <TooltipEl
            attrs={{
              type: DisplayType.Error,
              'always-show': true,
            }}
          >
            {error.to}
          </TooltipEl>
        ) : null}
      </div>
      <div sel='.calendars'>
        <CalendarEl
          attrs={this.helpers.getCalendarAttrs()}
          on={{
            draw: this.helpers.propagateEvent,
            selectDate: isFixedRange ? this.helpers.selectedFixedRangeDate : this.helpers.selectedDate,
          }}
        />
      </div>
    </div>
  );
}
